export function toInt<T extends number>(value: number, digits: number): T {
  if (value < 1) {
    const matches = String(value).match(/([0-9.-]+)e([0-9.-]+)/);
    if (matches) {
      return Math.floor(
        parseFloat(`${matches[1]}e${Number(matches[2]) + digits}`)
      ) as T;
    }
  }
  return Math.floor(parseFloat(`${value}e${digits}`)) as T;
}

export function toFloat<T extends number>(value: number, digits: number): T {
  return parseFloat(`${value}e-${digits}`) as T;
}

export const toFormatFixed = (
  value: number,
  decimals: number,
  digitDelimiter = ''
): string => {
  const num = value.toFixed(Math.max(0, ~~decimals));
  return digitDelimiter
    ? num.replace(
        new RegExp(`\\d(?=(\\d{3})+${decimals > 0 ? '\\.' : '$'})`, 'g'),
        `$&${digitDelimiter}`
      )
    : num;
};

export const toFloatFixed = (value: number, digits: number): string =>
  toFormatFixed(toFloat(value, digits), digits);
